













import { Component, Vue } from "vue-property-decorator";
import GalleryFormatRecuclerList from "@/components/tables/gallery/gallery-format-recucler-list.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

import { IPhotoFormat } from "@/@types/gallsery/gallery";
import axios from "@/api/AuthAPI/auth-request-api";
import { gallerys } from "@/config/host.config";
import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";

@Component({
  components: {
    GalleryFormatRecuclerList,
    ButtonBack,
  },
})
export default class FormatsGellaryRecucler extends Vue {
  formats: Array<IPhotoFormat> = [];

  update(id: string): void {
    for (let i = 0; i < this.formats.length; i++) {
      if (id == this.formats[i]._id) {
        this.formats.splice(i, 1);
        this.$emit("start");
        return;
      }
    }
  }

  async getGalleryRofmats(
    uri: string,
    config: AxiosRequestConfig
  ): Promise<Array<IPhotoFormat>> {
    return new Promise<Array<IPhotoFormat>>((res, rej) => {
      axios
        .get(uri, config)
        .then((response: AxiosResponse) => {
          if (response.status === 200) res(response.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  createGalleryDeletedFormats(): void {
    const uri = gallerys.formats;
    const config: AxiosRequestConfig = {
      params: { "match[deleted][value]": true },
    };
    this.getGalleryRofmats(uri, config)
      .then((categorys: Array<IPhotoFormat>) => {
        this.formats = categorys;
      })
      .catch((e: AxiosError) => {
        console.log(e);
      });
  }

  mounted(): void {
    this.createGalleryDeletedFormats();
  }
}
